import { Badge } from '@platform/design-system';
import type { OptionValue } from './options.ts';
import { originLabelOf } from './origin.ts';
import { usePageContext } from '../usePageContext.ts';

export const useOriginLabel = () => {
  const { t, locale } = usePageContext();
  const labels = {
    local: t('origin.local'),
    imported: (country: string) => t('origin.imported', { country }),
  };
  return (value: Pick<OptionValue, 'countryCode'>) => originLabelOf(value, labels, locale);
};

export const OriginBadge = ({ value }: { value: Pick<OptionValue, 'countryCode'> }) => {
  const labelOf = useOriginLabel();
  return <Badge tone="neutral">{labelOf(value)}</Badge>;
};
